module.exports = __webpack_public_path__ + "img/header_top.d43d2515.png";